<template>
  <zt-button
    color="dark-400"
    icon="angle-left"
    text
    class="go-back"
    data-vs-button="go_back"
    @click="goBack"
  >
    {{ $t('message.customEmails.go_back_btn') }}
  </zt-button>
</template>

<script>
export default {
  name: 'ZtGoBackButton',
  methods: {
    hasHistory() {
      return window.history.length > 2
    },
    goBack() {
      this.hasHistory() ? this.$router.go(-1) : this.$router.push('/')
    }
  }
}
</script>

<style scoped>
.zt-button.go-back {
  background: none !important;
  color: #707070 !important;
  padding: 4px !important;
  margin: 0;
  font-size: 1.2rem !important;
}

.zt-button.go-back span:first-child {
  width: 10px;
}

span.zt-button-text {
  margin-top: 2px;
}
</style>
